var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.386,
    y: 61.386,
    width: 67.1583,
    height: 22.3861,
    rx: 2.70177,
    fill: "white",
    stroke: "#ADE8F4",
    strokeWidth: 0.771935
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9652,
    y: 67.8242,
    width: 53,
    height: 4,
    fill: "#CAF0F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9652,
    y: 73.8242,
    width: 15,
    height: 4,
    fill: "#CAF0F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.386,
    y: 90.386,
    width: 57.8951,
    height: 22.3861,
    rx: 2.70177,
    fill: "white",
    stroke: "#ADE8F4",
    strokeWidth: 0.771935
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3341,
    y: 96.334,
    width: 42,
    height: 4,
    fill: "#CAF0F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3341,
    y: 103.334,
    width: 11,
    height: 3,
    fill: "#CAF0F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.386,
    y: 32.386,
    width: 76.4215,
    height: 22.3861,
    rx: 2.70177,
    fill: "#CAF0F8",
    stroke: "#48CAE4",
    strokeWidth: 0.771935
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5977,
    y: 38.5781,
    width: 60,
    height: 4,
    fill: "#90E0EF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5977,
    y: 44.5781,
    width: 17,
    height: 4,
    fill: "#90E0EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySkills);
export default __webpack_public_path__ + "static/media/Empty_Skills.002f079397cd074193968226e96f7fe2.svg";
export { ForwardRef as ReactComponent };